import React, { useState } from "react";

import { FormButton } from "components";

import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { SFVoucherDel } from "services/services-mia/SFHotel/SFVoucherDel";

export default function DeleteModal({ updateList, closeModal, voucher }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await SFVoucherDel({
            SFVoucherId: voucher.SFVoucherId
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "El Voucher ha sido eliminado exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                voucherId: voucher.SFVoucherId
            }}
            onSubmit={(_, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>

                    <h2 style={{ textAlign: "center" }}>
                        ¿Estás seguro que deseas eliminar el Voucher <strong>{voucher.SFVoucherNumero}</strong> ?
                    </h2>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />

                </div>
            </Form>
        </Formik>
    );
}